import { props } from "bluebird";
import React from "react";
import Avatar from '@material-ui/core/Avatar';
import ImageIcon from '@material-ui/icons/Image';
import CheckIcon from '@material-ui/icons/Check';
import ErrorIcon from '@material-ui/icons/ErrorOutline';
import CloseIcon from '@material-ui/icons/Close';
import Button from "@material-ui/core/Button";

import Styles from "./ModalTextAndButton.module.css";

const ModalTextAndButton = (props) => {
  return (
      <div className={Styles["ModalTextAndButton"]}>
        <CloseIcon className={Styles["CloseModal"]} style={{"cursor": "pointer"}} onClick={props.onCancel}/>
        <div className={Styles["ModalContent"]}>
          <Avatar className={Styles["ModalIcon"]}>
              {props.status === 0 && <ErrorIcon className={Styles["imageIcon"]} />}
              {props.status === 1 && <CheckIcon className={Styles["imageIcon"]} />}
          </Avatar>
          <div className={Styles["modal-title"]}>{props.title}</div>
          <div className={Styles["modal-text"]}>{props.text}</div>
          <Button variant="contained" color="primary" className={Styles["modal-button"]} onClick={props.onCancel}>
            Ok
          </Button>
        </div>
      </div>
  );
};
export default ModalTextAndButton;